import { ReactNode } from 'react'
import { useTw } from '../Styles'
import { useWidgetOpen } from '..'
import { useProfile } from '../Profile'
import { useNavigate } from 'react-router-dom'
import { ChevronLeftIcon, XIcon } from '@heroicons/react/outline'

type Props = {
  back?: string | false
  title: string
  subtitle?: string
  children: ReactNode
}

export default function Wrapper({
  back = '/',
  title,
  subtitle = null,
  children,
}: Props) {
  const tw = useTw()
  const profile = useProfile()
  const navigate = useNavigate()
  const { responsive, isMobile, setOpen } = useWidgetOpen()

  return (
    <section className={tw`h-full`}>
      <div
        style={{ background: profile?.background?.background ?? '#1E1E31' }}
        className={tw`relative z-10 flex items-center bg-fixed h-20  rounded-t-lg ${
          responsive && isMobile && 'rounded-none'
        }`}
      >
        {back !== false ? (
          <div
            onClick={() => navigate(back)}
            className={tw`flex items-center ml-4 mr-2 cursor-pointer`}
          >
            <ChevronLeftIcon className={tw`h-6 w-6 text-background-text`} />
          </div>
        ) : null}
        <div className={tw`h-full flex-grow ml-4 py-5 text-background-text`}>
          <p className={tw`text-sm`}>{title}</p>
          {subtitle}
        </div>
        {responsive ? (
          <button
            onClick={() => setOpen(false)}
            className={tw`flex ml-2 mr-4 focus:outline-none ${
              !isMobile && 'hidden'
            }`}
          >
            <XIcon className={tw`h-7 w-7 text-background-text`} />
          </button>
        ) : null}
      </div>
      <div className={tw`-mt-20 pt-20 h-full overflow-y-scroll`}>
        {children}
      </div>
    </section>
  )
}

export function LoadingSpinner() {
  const tw = useTw()
  return (
    <div className={tw`flex items-center justify-center h-full`}>
      <svg
        className={tw`animate-spin h-5 w-5 text-gray-700`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className={tw`opacity-25`}
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className={tw`opacity-75`}
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
  )
}

export function LoadingWrapper(props: Omit<Props, 'children'>) {
  return (
    <Wrapper {...props}>
      <LoadingSpinner />
    </Wrapper>
  )
}
